<mat-card class="data-card">
    <mat-card-content>
        <!-- Estado de carga -->
        <div class="loading-container" *ngIf="isLoading">
            <div class="loading-spinner">
                <i class="ri-loader-4-line"></i>
                <p>Cargando usuarios...</p>
            </div>
        </div>

        <div class="liquidaciones-list-table" *ngIf="!isLoading">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">

                    <!-- User Column -->
                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-0">
                            User
                        </th>
                        <td mat-cell *matCellDef="let element" class="pl-0">
                            <div class="user-info d-flex align-items-center">
                                <div class="image">
                                    <img [src]="element.user.img" alt="user-image">
                                </div>
                                <div class="info">
                                    <h6 class="mt-0">
                                        {{element.user.name}}
                                    </h6>
                                    <span class="d-block text-body">
                                        {{element.user.number}}
                                    </span>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Email
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.email}}
                        </td>
                    </ng-container>

                    <!-- Roles Column -->
                    <ng-container matColumnDef="roles">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Roles
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-primary">
                            {{element.roles}}
                        </td>
                    </ng-container>

                    <!-- Projects Column -->
                    <ng-container matColumnDef="projects">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Projects
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.projects}}
                        </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="trinta-badge fw-medium d-inline-block" *ngIf="element.status.active">
                                {{element.status.active}}
                            </span>
                            <span class="trinta-badge fw-medium deactive d-inline-block" *ngIf="element.status.deactive">
                                {{element.status.deactive}}
                            </span>
                            <span class="trinta-badge fw-medium converted d-inline-block" *ngIf="element.status.converted">
                                {{element.status.converted}}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-end pr-0"></th>
                        <td mat-cell *matCellDef="let element" class="text-end pr-0">
                            <div class="action">
                                <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" matTooltip="Editar usuario">
                                    <i class="{{element.action.edit}}"></i>
                                </button>
                                <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" matTooltip="Eliminar usuario">
                                    <i class="{{element.action.delete}}"></i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>

            <!-- Mensaje cuando no hay datos -->
            <div class="no-data" *ngIf="dataSource.data.length === 0 && !isLoading">
                <i class="ri-inbox-line"></i>
                <p>No se encontraron usuarios.</p>
            </div>

            <mat-paginator 
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                [pageIndex]="currentPage - 1"
                (page)="onPageChange($event)"
                showFirstLastButtons>
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>